export enum ContentSpaceCourseTableActionUiEnum {
  PUBLISH = 'PUBLISH',
  UNPUBLISH = 'UNPUBLISH',
  ADD_TO_PORTAL = 'ADD_TO_PORTAL',
  DELETE = 'DELETE',
}
